import axios from 'axios'
// import qs from 'qs';
import store from '../store'
import auth from "../auth/authService";
// before a request is made start the nprogress
axios.interceptors.request.use(config => {
    store.dispatch('dwc/setLoading', true);
    return config;
});
// before a response is returned stop nprogress
axios.interceptors.response.use(response => {
    store.dispatch('dwc/setLoading', false);
    return response;
});

export const initDealerInterceptors = () => {
    auth.addInterceptors(axios);
};

export const getDealerServiceData = (oem) =>
    new Promise((resolve, reject) => {
        const oemParam = !oem ? '' : oem;
        axios.get(`/api/portal/dwc/websiteprogram/async/dealerServiceData?oem=${oemParam}`)
            .then(response => resolve(response))
            .catch(error => {
                    store.dispatch('dwc/setLoading', false);
                    reject(error);
            })
    });

export const postLoginInfo = (data) =>
    new Promise((resolve, reject) => {
        const config = {
            'dataType': 'json',
            'withCredentials': true
        };
        axios.post('/mocdata/dwc.json', data, config)
            .then(response => resolve(response))
            .catch((error) => {
                store.dispatch('dwc/setLoading', false);
                reject(error)
            });
    });
